import Typography from "@material-ui/core/Typography";
import {colors} from "../../colors";
import React, {useCallback, useMemo} from "react";
import AutocompleteChip
    from "../../../components/ui/autocompletes/autocomplete-without-icon/autocomplete-chip/AutocompleteChip";
import Button from "@material-ui/core/Button";
import moment from "moment/moment";
import PropTypes from "prop-types";
import {useFilterHistoryStyles} from "./FilterHistoryStyles";
import Box from "@material-ui/core/Box";

const FilterHistory = (props) => {
    const classes = useFilterHistoryStyles();
    const removeBadge = useCallback((key, type, idx = 0) => {
        props.removeFilter(key, type, idx);
        props.fetchData();
    }, [props])

    const handleEliminaRicercaButton = () => {
        props.resetFilter();
        props.fetchData();
    }
    const renderChips = useMemo(() => {
        let chips = [];
        Object.keys(props.filter).forEach(key => {
            if (Array.isArray(props.filter[key].value)) {
                for (let i = 0; i < props.filter[key].value.length; i++) {
                    chips.push(<AutocompleteChip className={classes.filterChip} key={`filter-chip-${key}-${i}`}
                                                 size={"small"}
                                                 label={`${props.filter[key].label}: ${typeof props.filter[key].value[i] === 'object' ? props.filter[key].value[i].label : props.filter[key].value[i]}`}
                                                 onDelete={() => removeBadge(key, "array", i)}
                                                 style={{backgroundColor: "#7c92a5", color: "white"}}/>);
                }
            } else if (props.filter[key].name) {
                let label = props.filter[key].name;
                if (props.filter[key].from) {
                    label += `${props.filter[key].to !== undefined ? ' da ' : ''}${moment(props.filter[key].from).format("DD/MM/YY")}`
                }
                if (props.filter[key].to) {
                    label += ` a ${moment(props.filter[key].to).format("DD/MM/YY")}`
                }
                if (label !== props.filter[key].name) {
                    chips.push(<AutocompleteChip className={classes.filterChip} key={`filter-chip-${key}`}
                                                 size={"small"}
                                                 label={label} onDelete={() => removeBadge(key, "date")}
                                                 style={{backgroundColor: "#7c92a5", color: "white"}}/>);
                }

            } else {
                if (props.filter[key].value !== "") {
                    chips.push(<AutocompleteChip className={classes.filterChip}
                                                 key={`filter-chip-${key}`}
                                                 size={"small"}
                                                 label={`${props.filter[key].label}: ${props.filter[key].text ?? props.filter[key].value}`}
                                                 onDelete={() => removeBadge(key, "primitive")}
                                                 style={{backgroundColor: "#7c92a5", color: "white"}}/>);
                }
            }
        })
        return chips;
    }, [props.filter, classes.filterChip, removeBadge])


    return (
        renderChips.length && props.filterClicked ? <Box marginBottom={"2em"}>
            <Typography className="d-inline-block mr-16" variant="body2" style={{color: colors.font.light}}>Risultati
                per</Typography>
            {renderChips}
            <Button className="ml-8" color="primary" onClick={handleEliminaRicercaButton}>Elimina ricerca</Button>
        </Box> : null

    )
}
FilterHistory.propTypes = {
    filter: PropTypes.object.isRequired,
    resetFilter: PropTypes.func.isRequired,
    removeFilter: PropTypes.func.isRequired,
    fetchData: PropTypes.func,
    filterClicked: PropTypes.bool
}

FilterHistory.defaultProps = {
    filterClicked: true,
    fetchData: () => {
    }
}

export default FilterHistory;
